<template>
  <div class="auth" :class="{ _mobile: isMobile }">
    <div class="auth__logo">
      <b-logo type="dark" />
    </div>

    <div class="auth__inner">
      <div class="auth__content">
        <header class="auth__header">
          <b-logo-small />

          <Button
            icon="pi pi-ellipsis-h"
            text
            rounded
            raised
            aria-haspopup="true"
            aria-controls="api_options"
            @click="toggleApiBases" />

          <Menu id="api_options" ref="loginMenu" :model="apiBases" popup />
        </header>

        <slot />

        <footer v-if="$slots.footer" class="auth__footer">
          <slot name="footer" />
        </footer>
      </div>

      <Button
        icon="pi pi-ellipsis-h"
        outlined
        rounded
        raised
        aria-haspopup="true"
        aria-controls="api_options"
        class="auth__menu"
        @click="toggleApiBases" />
    </div>

    <modal-manager />

    <Toast position="bottom-right" group="br" />
  </div>
</template>

<script setup lang="ts">
const { t: $t } = useI18n()

import { PrimeIcons } from 'primevue/api';

const { isMobile } = useScreens();

const apiStore = useApiStore();

const loginMenu = ref();

const config = useRuntimeConfig();

const toggleApiBases = (event: MouseEvent) => {
  loginMenu.value.toggle(event);
};

const apiBases = computed(() =>
  [
    {
      label: 'login.api-bases.swiss',
      apiBase: config.public.apiBase,
      wsBase: config.public.wsBase
    },
    {
      label: 'login.api-bases.swiss-plus',
      apiBase: config.public.apiBasePhoenix,
      wsBase: config.public.wsBasePhoenix
    }
  ].map(({ label, apiBase, wsBase }) => ({
    label: $t(label),
    icon: apiStore.apiBase === apiBase ? PrimeIcons.CHECK : undefined,
    command: () => {
      apiStore.setApiBase(apiBase, wsBase);
    }
  }))
);
</script>

<style lang="postcss">
.auth {
  @apply flex min-h-screen flex-col bg-primary-500;

  &__inner {
    @apply relative flex-grow p-6;
  }

  &__logo {
    @apply h-[40vh] p-6;

    .b-logo,
    .icons {
      @apply h-full w-full;
    }
  }

  &__header {
    @apply mb-4 hidden items-center justify-between;
  }

  &__content {
    @apply mx-auto max-w-[423px] rounded-2xl bg-white px-10 pb-10 pt-8;
  }

  &__menu {
    @apply absolute bottom-6 right-6;
  }

  &__title {
    @apply mb-8 text-2xl;
  }

  &__footer {
    @apply mt-8;
  }

  &._mobile {
    @apply bg-white min-h-screen-safe;

    .auth {
      &__inner {
        @apply max-w-full p-0 h-screen-safe;
      }

      &__header {
        @apply flex;
      }

      &__logo {
        @apply hidden;
      }

      &__content {
        @apply flex h-screen flex-col rounded-none px-4 pt-10;
      }

      &__menu {
        @apply hidden;
      }

      &__footer {
        @apply mt-auto;
      }
    }
  }
}
</style>
